<template>
    <div
        id="app"
        :class="[ { 'no-scroll' : noScroll }, `theme-${ themeSelected }` ]"
    >
        <div class="app-container">
            <nav-drawer
                :class="{'nav-container--closed' : !isNavExpanded}"
                :drawer="isNavExpanded"
                class="nav-container"
                @onNavMounted="onNavMounted"
            />
            <div
                :class="[
                    'main-container d-flex flex-column',
                    !isNavExpanded && 'nav-collapsed'
                ]"
            >
                <main class="main">
                    <router-view
                        :id="routeName"
                        class="module"
                    />
                </main>
                <app-footer />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { NavDrawer, AppFooter } from '@/components/layout/';
import debounce from 'lodash/debounce';
import { getNavState, saveNavState } from '@/helpers/nav';

export default {
    name: 'Full',

    components: {
        AppFooter,
        NavDrawer,
    },

    data () {
        const savedNavState = getNavState() ? getNavState() === 'true' : null;

        return {
            innerWidth: window.innerWidth,
            navWidth: 220,
            breakpoint: 1441,
            savedNavState: savedNavState,
            isNavExpanded: savedNavState !== null ? savedNavState : !(this.innerWidth < this.breakpoint),
        };
    },

    computed: {
        ...mapGetters([
            'config',
            'themeSelected',
        ]),
        noScroll () {
            return this.isNavExpanded && (this.innerWidth < this.breakpoint);
        },
        routeName () {
            return this.$route.name;
        },
    },

    watch: {
        'isNavExpanded' () {
            if (this.savedNavState !== null) {
                window.removeEventListener('resize', this.onResizeDebounced);
            }
        },
        themeSelected: {
            handler () {
                if (this.themeSelected) {
                    document.body.className = document.body.className.replace(/theme-\w+/g, '');
                    document.body.classList.add(`theme-${ this.themeSelected }`);
                }
            },
            immediate: true,
        },
    },

    created () {
        this.onResizeDebounced = debounce(() => this.onResize(), 100);

        if (this.savedNavState === null) {
            window.addEventListener('resize', this.onResizeDebounced);
            this.onResizeDebounced();
        }

        this.$eventHub.$on('toggleNav', () => {
            this.isNavExpanded = !this.isNavExpanded;
            this.savedNavState = this.isNavExpanded;
            saveNavState(this.isNavExpanded);
        });

    },

    beforeDestroy () {
        window.removeEventListener('resize', this.onResizeDebounced);
    },

    methods: {
        onResize () {
            this.innerWidth = window.innerWidth;
            this.isNavExpanded = !(this.innerWidth < this.breakpoint);
        },

        onNavMounted (nav) {
            this.navWidth = nav.clientWidth;
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
}

.app-container {
    overflow-y: scroll;
    height: 100vh;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
}

</style>
